// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"786":"a09d17ce","850":"bd33a71d"}[chunkId] + ".chunk.css";
};